<div class="cookie-main">
  <div class="col-lg-12 row">
    <div class="col-lg-1"></div>
    <div class="col-lg-10">
      <div class="text-center heading-main p-3">COOKIE POLICY </div>
      <div class="risk-data">

        <div class="risk-content p-3">
          <p class="danger-text"><b>ITI’s cookie policy</b> outlines how we use cookies and how to manage and delete them.
          </p>

        </div>
      </div>

      <div class="heading-sub  pt-3 pl-3">
        What are cookies?
      </div>
      <div class="risk-content p-3">
        <p>Most other websites today use cookies, just like us. Cookies are small text files stored on your computer or
          mobile device by your browser. They are used for multiple reasons such as remembering whether you have visited
          our site before or matching content to your preferred interests. Most often theyoffer us an idea of how many
          new website visitors we receive each month and help us understand the relevancy of the content we offer.

          .</p>

      </div>
      <div class="heading-sub  pt-3 pl-3">
        We do not store personally identifiable data such as:

      </div>
      <div class="risk-content">
        <div class=" li-data">
          <ul>
        <li>Names</li>
        <li>Phone numbers</li>
        <li>Email addresses</li>
        <li>Mailing addresses</li>
        <li>Bank Account Numbers</li>
        <li>Credit Card Information</li>
      </ul>
      </div>
        <br>
        <div class="last-content">
        <p>We might store information entered in tools, such as calculators on our website. This information may need to
          be temporarily stored to help us deliver these types of services efficiently and is not used for any other
          means.If you choose not to allow cookies, the quality of your browsing experience may be reduced.

        </p>
        <p>
          Information collected by cookies identifies your computer and your connection to the internet. We collect
          general information about your computer settings, and your connection to the internet, for example your
          operating system and platform, IP address, browsing patterns and interactions with our sites.


        </p>
        <p>
          When you log in to our site with your Customer ID we are able to identify who you are. This helps us to
          contact you should you submit any feedback on our website.


        </p>

      </div>
    </div>
    </div>

  </div>
  <div class="col-lg-1"></div>
</div>
